import React from 'react';
import { bool, func } from 'prop-types';
import { noop } from 'lodash';
import { useGigPageContext } from '@fiverr-private/gig_page_context';
import { I18n } from '@fiverr-private/i18n-react';
import { Button as PentaButton } from '@fiverr-private/button';
import { ArrowRightIcon } from '@fiverr-private/visuals';
import { Button, Icon } from '@fiverr-private/fit';
import { l_arrow_right } from '@fiverr-private/icons';
import { getCheckoutCtaCopyKey } from './getCheckoutCtaCopy';

const OpenDrawerButton = ({ onClick = noop, loading = false, isRestrictedByRegion }) => {
    const continueCopyKey = getCheckoutCtaCopyKey();
    const { isInCheetahsMobileGigPage } = useGigPageContext();

    if (isInCheetahsMobileGigPage) {
        return (
            <PentaButton
                type="button"
                onClick={onClick}
                loading={loading}
                disabled={isRestrictedByRegion}
                size={{ default: 'lg', sm: 'md' }}
                fullWidth={{ default: true, sm: false }}
            >
                <I18n k={continueCopyKey} />
                <ArrowRightIcon color="white" />
            </PentaButton>
        );
    }

    return (
        <Button
            type="button"
            onClick={onClick}
            loading={loading}
            color={Button.COLORS.BLACK}
            disabled={isRestrictedByRegion}
        >
            <I18n k={continueCopyKey} />
            <Icon className="rf" color={Button.COLORS.WHITE}>
                {l_arrow_right}
            </Icon>
        </Button>
    );
};

OpenDrawerButton.propTypes = {
    onClick: func,
    loading: bool,
    isRestrictedByRegion: bool,
};

export default OpenDrawerButton;
